"use strict";

var registry = {};
var schemaRegistry = {};

module.exports.schemaRegistry = schemaRegistry;

module.exports.EntityProvider = function (entityName) {
  if (Object.keys(registry).includes(entityName)) {
    return registry[entityName];
  } else {
    throw Error("Type " + entityName + " is not yet implemented");
  }
};

module.exports.registerEntity = function (name, clazz) {
  registry[name] = clazz;
};

module.exports.EntitySchemaProvider = function (entityName) {
  if (Object.keys(schemaRegistry).includes(entityName)) {
    return schemaRegistry[entityName];
  } else {
    return {};
  }
};

module.exports.registerEntitySchema = function (name, clazz) {
  schemaRegistry[name] = clazz;
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/entity/entityProvider.js
// module id = kia4
// module chunks = 0